import { createSelector } from 'reselect';
import { JobStatusPickerPopoverOptionEnum } from './job-status-picker-popover-option.enum';
import { JobStatusPickerOption } from './job-status-picker-popover-option.model';
import * as actions from './job-status-picker-popover.actions';

export interface State {
    options: Array<JobStatusPickerOption>;
}

export const initialState: State = {
    options: []
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {

    switch (action.type) {
        case actions.LOAD_SUCCESS: {
            return {
                ...state,
                options: action.payload
            };
        }
        case actions.TOGGLE_OPTION: {

            let option: JobStatusPickerOption = action.payload;

            option = {
                ...option,
                selected: !option.selected,
                children: option.type === JobStatusPickerPopoverOptionEnum.CATEGORY_GROUP ?
                    option.children.map(child => ({...child, selected: !option.selected})) :
                    option.children
            };

            return {
                ...state,
                options: state.options.map(o => {
                    if (o.id === option.id) {
                        return option;
                    }

                    return {
                        ...o,
                        children: o.children.map(c => {
                            return c.id === option.id ? option : c;
                        })
                    };
                })
            };
        }
        default: {
            return state;
        }
    }
}

export const getState = state => state.jobStatusPicker;

export const getOptions = createSelector(getState, (state: State) => state.options);

const getSelectedJobStatusIdsHelper = (options: Array<JobStatusPickerOption>): Array<string> => {
    let ids = [];

    options.forEach(option => {
        if (option.type === JobStatusPickerPopoverOptionEnum.JOB_STATUS && option.selected) {
            ids.push(option.id);
        } else if (option.type === JobStatusPickerPopoverOptionEnum.CATEGORY_GROUP) {
            ids = ids.concat(getSelectedJobStatusIdsHelper(option.children));
        }
    });

    return ids;
};

export const getSelectedJobStatusIds = createSelector(getOptions, getSelectedJobStatusIdsHelper);



// WEBPACK FOOTER //
// ./src/app/atoms/job-status-picker-popover/job-status-picker-popover.reducer.ts